import React, {useRef, useState} from 'react'
import BootstrapTable from 'react-bootstrap-table-next';
import {Button, OverlayTrigger, Tooltip} from 'react-bootstrap';
import filterFactory, {textFilter, numberFilter, Comparator, dateFilter} from 'react-bootstrap-table2-filter';
import ToolkitProvider, {
    CSVExport,
    ColumnToggle
} from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min';
import paginationFactory, {
    PaginationProvider,
    PaginationTotalStandalone,
    PaginationListStandalone
} from 'react-bootstrap-table2-paginator';
import Moment from "moment";
// import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';

const MyExportCSV = (props) => {
    const handleClick = () => {
        props.onExport();
    };
    return (
        <button className="btn btn-success" onClick={handleClick}>
            Export Visible Data
        </button>
    );
};

const {ToggleList} = ColumnToggle;
const columns = [{
    dataField: 'index',
    text: 'Index',
    sort: true
}, {
    dataField: 'uid',
    text: 'Uid',
    filter: textFilter(),
    filterValue: arrayFormatterForFilters,
    formatter: arrayFormatter,
    csvFormatter: arrayCsvFormatter
}, {
    dataField: 'totalValue',
    text: 'Total',
    filter: numberFilter({
        defaultValue: {number: 0, comparator: Comparator.GT}
    })
}, {
    dataField: 'visits',
    text: 'Visits',
    filter: numberFilter({
        defaultValue: {number: 0, comparator: Comparator.GT}
    })
}, {
    dataField: 'billNumber',
    text: 'Bill Number',
    sort: true,
    filter: textFilter()
}, {
    dataField: 'campaignId',
    text: 'Campaign',
    sort: true,
    filter: textFilter()
}, {
    dataField: 'value',
    text: 'Value',
    sort: true,
    filter: numberFilter({
        defaultValue: {number: 0, comparator: Comparator.GT}
    })
}, {
    dataField: 'country',
    text: 'Country',
    sort: true,
    hidden: true,
    filter: textFilter()
}, {
    dataField: 'city',
    text: 'City',
    sort: true,
    filter: textFilter()
}, {
    dataField: 'companyCode',
    text: 'Company',
    sort: true,
    hidden: true,
    filter: textFilter()
}, {
    dataField: 'storeId',
    text: 'Store Id',
    sort: true,
    filter: textFilter()
}, {
    dataField: 'voucher',
    text: 'Voucher',
    sort: true,
    hidden: true,
    filter: textFilter()
}, {
    dataField: 'posId',
    text: 'Pos Id',
    sort: true,
    hidden: true,
    filter: textFilter()
}, {
    dataField: 'status',
    text: 'Status',
    hidden: true,
    sort: true,
    filter: textFilter()
}, {
    dataField: 'username',
    text: 'Username',
    hidden: true,
    sort: true,
    filter: textFilter()
}, {
    dataField: 'items',
    text: 'Items',
    hidden: true,
    sort: true,
    filter: textFilter(),
    formatter: lineFormatter
}, {
    dataField: 'time',
    text: 'Time'
}, {
    dataField: 'timestamp',
    text: 'Date',
    hidden: false,
    filter: dateFilter(),
    formatter: dateFormatter,
    csvFormatter: dateFormatter,
    sort: true
}, {
    dataField: 'scanTimeDiff',
    text: 'Seconds to Scan',
    hidden: false,
    filter: numberFilter({
        defaultValue: {number: 0, comparator: Comparator.GT}
    }),
    formatter: scanTimeDiffHumanFormatFormatter,
    csvFormatter: scanTimeDiffFormatter,
    filterValue: scanTimeDiffFormatter,
    sort: true
}];

function lineFormatter(cell, row) {
    if (!cell || typeof cell !== 'string') {
        return '';
    }

    // Split the string by '; ' delimiter
    const items = cell.split('; ');

    // Return JSX with each item on a separate line
    return (
        <div>
            {items.map((item, index) => (
                <div key={index}>{item.trim()}</div>
            ))}
        </div>
    );
}

function scanTimeDiffFormatter(cell, row) {
    if (cell === null) {
        return -1;
    }
    return cell;
}

function scanTimeDiffHumanFormatFormatter(cell, row) {
    if (cell === null) {
        return -1;
    }
    return secondsToHms(cell);
}

function secondsToHms(d) {
    d = Number(d);
    const h = Math.floor(d / 3600);
    const m = Math.floor(d % 3600 / 60);
    const s = Math.floor(d % 3600 % 60);
    const timeElements = [];
    if (h > 0) timeElements.push(h + "h");
    if (m > 0) timeElements.push(m + "m");
    if (s > 0) timeElements.push(s + "s");
    return timeElements.join(':');
}

function dateFormatter(cell, row) {
    return Moment.tz(cell, 'Europe/Belgrade').format('DD.MM.YYYY');
}

function arrayCsvFormatter(cell, row) {
    return cell.uid;
}

function arrayFormatterForFilters(cell, row) {
    return cell.uid;
}

function arrayFormatter(cell, row) {
    return (
        <OverlayTrigger placement="right"
                        delay={{show: 250, hide: 400}}
                        overlay={
                            <Tooltip id="button-tooltip-{item.uid}-{row}">
                                uid: {cell.uid}<br/>
                                name: {cell.firstName}<br/>
                                gender: {cell.gender}<br/>
                                birthday: {cell.birthday}<br/>
                                visits: {cell.count}<br/>
                                value: {cell.value}<br/>
                                bonuses: {cell.periodFilled}<br/>
                                list of cities: {cell.listOfCities}<br/>
                                list of company code: {cell.listOfCompanyCodes}<br/>
                                list of stores: {cell.listOfStoresId}<br/>
                                last visit: {cell.date} {cell.time}
                            </Tooltip>
                        }
        >
            <div style={{cursor: "pointer", color: "blue"}}>{cell.uid}</div>
        </OverlayTrigger>
    )
}

export const Scans = ({scans, handleNewCampaignListUid, exportRawButton, fetchScansByUids}) => {
    let bootstrapTableContainer = useRef(null)
    const [uidSearchInput, setUidSearchInput] = useState('');
    const [isSearching, setIsSearching] = useState(false);

    const rowEvents = {
        onClick: (e, row, rowIndex) => {
            // alert("Row index: " + (rowIndex + 1));
        }
    };

    const handleUidSearch = async () => {
        if (!uidSearchInput.trim()) return;

        // Parse comma-separated UIDs, trim whitespace
        const uids = uidSearchInput.split(',')
            .map(uid => uid.trim())
            .filter(uid => uid.length > 0);

        if (uids.length === 0) return;

        setIsSearching(true);
        try {
            await fetchScansByUids(uids);
        } finally {
            setIsSearching(false);
        }
    };

    const options = {
        sizePerPageList: [{text: '50', value: 50}, {text: '100', value: 100}, {text: '250', value: 250}, {
            text: 'All',
            value: scans.length
        }],
        showTotal: true
    }

    const handleNewCampaign = () => {
        const currentTableData = bootstrapTableContainer.filterContext.data;
        if (!currentTableData.length) {
            return;
        }
        const listOfFilteredUidFromTable = currentTableData.map(row => row.uid).map(row => row.uid);
        const unique = [...new Set(listOfFilteredUidFromTable)];
        handleNewCampaignListUid(unique);
    };

    return (
        <ToolkitProvider
            keyField='index'
            data={scans}
            columns={columns}
            columnToggle
            pagination={paginationFactory(options)}
            exportCSV={{
                exportAll: false,
                onlyExportFiltered: true
            }}>
            {props => (
                <div className="table-card">
                    {/* UID Search Section */}
                    <div className="p-4 mb-4 bg-gray-100 rounded-lg border border-gray-200">
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Pretrazi po UID-ovima (razdvojeni zarezom):
                        </label>
                        <div className="flex flex-wrap items-center gap-3">
                            <input
                                type="text"
                                className="flex-1 min-w-64 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                placeholder="uid1, uid2, uid3..."
                                value={uidSearchInput}
                                onChange={(e) => setUidSearchInput(e.target.value)}
                                onKeyPress={(e) => e.key === 'Enter' && handleUidSearch()}
                            />
                            <Button
                                variant="outline-primary"
                                onClick={handleUidSearch}
                                disabled={isSearching || !uidSearchInput.trim()}
                            >
                                {isSearching ? 'Trazim...' : 'Pretrazi'}
                            </Button>
                        </div>
                    </div>

                    {/* Table Actions */}
                    <div className="table-actions">
                        <div className="flex flex-wrap items-center gap-3">
                            <MyExportCSV {...props.csvProps}/>
                            {exportRawButton}
                            <Button variant="primary" onClick={handleNewCampaign}>
                                New Campaign For Visible Data
                            </Button>
                        </div>
                    </div>

                    {/* Column Toggle */}
                    <div className="column-toggle-section">
                        <p className="column-toggle-label">Show/Hide Columns:</p>
                        <ToggleList {...props.columnToggleProps} />
                    </div>

                    {/* Table */}
                    <div className="table-responsive">
                        <BootstrapTable striped bordered hover {...props.baseProps}
                                        ref={node => bootstrapTableContainer = node}
                                        pagination={paginationFactory(options)}
                                        rowEvents={rowEvents}
                                        bootstrap4={true}
                                        tabIndexCell
                                        filter={filterFactory()}
                        />
                    </div>
                </div>
            )
            }
        </ToolkitProvider>
    )
}